import { z } from "zod"
import { ServiceBikeType } from "../service/service-bike"

// Request schemas
export const EventCheckInVerifyCodeRequestSchema = z.object({
  phoneNumber: z.string().min(1),
  code: z.string().length(4),
})

export type EventCheckInVerifyCodeRequest = z.infer<
  typeof EventCheckInVerifyCodeRequestSchema
>

// Response types
export interface EventBookingForCheckIn {
  jobId: string
  event: {
    id: string
    title: string
    eventDate: Date
    startTime: string
    endTime: string
    address: string | null
  }
  customer: {
    firstName: string
    lastName: string | null
    email: string | null
    phoneNumber: string
  }
}

export interface EventCheckInVerifyCodeResponse {
  verified: boolean
  errorReason?: "no_code_found" | "code_expired" | "code_incorrect"
  eventBookings: EventBookingForCheckIn[]
  isClubMember: boolean
}

export interface EventCheckInSubmitResponse {
  jobId: string
  code: string
  event: {
    id: string
    title: string
    eventDate: Date
    startTime: string
    endTime: string
    address: string | null
  }
  customer: {
    firstName: string
    lastName: string | null
    email: string | null
    phoneNumber: string
  }
  bikeInfo: {
    type: string
    brand: { id: string; name: string } | null
    model: string | null
    color: string | null
    isElectric: boolean
  } | null
}

export interface EventCheckInStoreDataResponse {
  storeName: string
  storeSlug: string
  customerClub: {
    id: string
    name: string
    linkToInfo: string | null
  } | null
  supportedBikeTypes: ServiceBikeType[]
  privacyPolicyUrl: string
  termsOfServiceUrl: string
}
